var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_52_569",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_52_569",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAANpSURBVHic7Z3hVdswFIWvejoAG8AI2YCMwAY1G7QbdIRuEGeCwgSECWgnKBsUJrj9YZtDTWIr1rPfk/W+v1hPyv2QjiM7NuA4juM4juM4jpMIyS3JHck/tEGlnckikLwg+aAc9ikq7XxmhU34T9opj1Bp53SMT0J1fgLYCNWai51FCckC2g+1TR7JMpiTIDEDbgRqLIkpCSG1AElKDESIRwDPAL5EHHsbQqhnHU0ESTOA5JXQOMQIIVQA9hGHmpgJqUvQlcQgpMlJgtRZkDlykbBaAUAeElYtALAvYfUCANsSihAA2JVQjADApoSiBAD2JBQnALAloUgBgB0JxQoAbEgoWgCgL6F4AYCuBBfQoiXBBbxDQ4IL6LG0BBdwhDMkVKl9uYATnCEhCRcwwBISXMAIc0v4PFdhJa6N3aUxis8AZVyAMi5AGRegjAtQxgUo4wKUcQHKuABlXIAyLkAZF6BMiQL2WGCfP5a17YaOsW+3l9Fumsb8lmxWSpoBb+EDy13xGqMUAf+F32FBQgkCjobfoS3BuoB7AK8J7QfD72iPuU/oZzKWBexDCDdoHoMwRUJU+ABAcgPgekIfurB5NtAc1L1+NiRfprYf+Qwbkn8njvMgHOl5cB4B9Ym+YiUcbT9Qc2r45AoF1CP9jUkYbH+kVkr45MoE1JF9npIQ1f5djdTwyRUJqM/sty8huj3lwidXIqCe2HcnIbo9ZcMnBQRo7wVFnyr2CSH8IrkJITzHHM/mVPMBwMWU/uZC83vA5PA7cg8f0BOQHH4slsMH9AQcYg5i4hO5rIcP6AnYceTnPW14TyR3UzrIIfxkmH4WVJ2o2z9bOUvCkfZzcZDIcTKUOQ2tejVPhRclYaD9HBxSM7SwG7rrJHB42ajGJIy0N4n294COHclLAF8xHF5FEiGE2/4fcgwfsCMAAL5HHvdBQq7hAzaWoCm8LUc5hw/YmgHnUpG8QHPFLMvwgbwFAPk9OPwDuS5Bq8EFKOMClHEByrgAZVIFPEsMomSSBMRekVoxL6kFJJYglXsqjXCXWkBCQC1QI0deYUFACOEOzduLSuNrCMHEEgQ0WwK/hWrlwF7qFVgiAtr/hC3WPxNeAXyTvKMj+UVufUhu0TzOcQvgUrq+Eo9o7uT4IbHsOI7jOI7jOI5TNv8AUwS00VshaXwAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.f1fa48854ab51be92a39a35d4aeed453.svg";
export { ForwardRef as ReactComponent };